<template>
  <div class="home">
    <!-- <div>
      <video
        style="width: 500px; height: 400px"
        id="video"
        src="https://gscb.kuaihd.com/mediadata/gzbn/product/src/2024/1213/059f21d7218b45cd8eccb5cf7e2003f01420546750966016.mp4"
        controls="true"
      />
    </div>
    <div>
      <canvas id="c1" width="160" height="96" />
      <canvas id="c2" width="160" height="96" />
    </div> -->
    <van-button type="primary" @click="toAccount">花城号详情</van-button>
    <van-button type="primary" @click="toArticle">文章详情</van-button>
    <van-button type="primary" @click="toCollection">图集详情</van-button>
    <van-button type="primary" @click="toPublish">服务号详情</van-button>
    <van-button type="primary" @click="toVideo">视频详情</van-button>
    <van-button type="primary" @click="toLive">直播详情</van-button>
    <van-button type="primary" @click="toCourse">课堂详情</van-button>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {};
  },
  // mounted() {
  //   this.video = document.getElementById("video");
  //   this.c1 = document.getElementById("c1");
  //   this.ctx1 = this.c1.getContext("2d");
  //   this.c2 = document.getElementById("c2");
  //   this.ctx2 = this.c2.getContext("2d");
  //   let self = this;
  //   this.video.addEventListener(
  //     "play",
  //     function () {
  //       self.width = self.video.videoWidth / 2;
  //       self.height = self.video.videoHeight / 2;
  //       self.timerCallback();
  //     },
  //     false
  //   );
  // },
  methods: {
    toAccount() {
      this.$router.push({
        name: "accountDetail",
        query: {
          id: "717",
        },
      });
    },
    toArticle() {
      this.$router.push({
        name: "articleDetail",
        query: {
          id: "1432156239572992",
        },
      });
    },
    toCollection() {
      this.$router.push({
        name: "articleDetail",
        query: {
          id: "638192f17d80c12b533d7eeb",
        },
      });
    },
    toPublish() {
      this.$router.push({
        name: "publishDetail",
        query: {
          id: "597",
        },
      });
    },
    toVideo() {
      this.$router.push({
        name: "videoDetail",
        query: {
          id: "1432152251196160",
        },
      });
    },
    toLive() {
      this.$router.push({
        name: "liveDetail",
        query: {
          id: "1432074999599872",
        },
      });
    },
    toCourse() {
      this.$router.push({
        name: "courseDetail",
        query: {
          id: "1368541080117248",
        },
      });
    },
  },
};
</script>

<style lang="scss">
.home {
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
</style>
